import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles(() => ({
  container: {
    width: 700,
    maxHeight: 820,
  },
  bodyContainer: {
    marginTop: 80,
  },
  footerStyle: {
    width: 150,
    marginLeft: 'auto',
    padding: 20,
  },
}));
